import React from 'react';
import { Link } from 'react-router-dom';
import { Frown } from 'lucide-react';

const ErrorPage = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 px-4 py-12 text-white">
      <div className="text-center">
        <div className="flex flex-col items-center">
          <h1 className="text-9xl font-extrabold text-blue-500">
            404
          </h1>
          <Frown size={100} className="mt-4 animate-bounce text-yellow-400" />
        </div>
        <h2 className="mt-8 text-4xl font-bold md:text-5xl">
          Page Not Found
        </h2>
        <p className="mt-4 max-w-lg text-lg text-gray-400">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex transform items-center space-x-2 rounded-full bg-blue-600 px-8 py-3 font-semibold text-white shadow-lg transition-all duration-300 hover:scale-105 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-500"
          >
            Go back home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
